import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import LoadScript from 'vue-plugin-load-script'
import Vuelidate from 'vuelidate'
import VueGtag from 'vue-gtag'
import VueMeta from 'vue-meta'
import Hotjar from '@hotjar/browser'

Vue.config.productionTip = false
Vue.use(LoadScript)
Vue.use(Vuelidate)
Vue.use(VueGtag, {
  config: { id: "G-53ZNRQ1MDQ" },
  includes: [
    { id: 'AW-398585351' },
  ],
}, router)
Vue.use(VueMeta)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


// Hotjar
const siteId = 3865842;
const hotjarVersion = 6;
Hotjar.init(siteId, hotjarVersion);
